export const facilitySubscriptionKeys = {
    all: ['facilitySubscription'] as const,
    list: (centerId: string) => [...facilitySubscriptionKeys.all, 'list', centerId] as const,
    summary: (centerId: string) => [...facilitySubscriptionKeys.all, 'summary', centerId] as const,
    memberList: (centerId: string, memberId: string) =>
        [...facilitySubscriptionKeys.all, 'member', centerId, memberId] as const,
    pausePeriods: (centerId: string, subscriptionId: string) =>
        [...facilitySubscriptionKeys.all, 'pausePeriods', centerId, subscriptionId] as const,
    transferPreview: (centerId: string, subscriptionId: string) =>
        [...facilitySubscriptionKeys.all, 'transferPreview', centerId, subscriptionId] as const,
    transfers: (centerId: string) => [...facilitySubscriptionKeys.all, 'transfers', centerId] as const,
};
